import React, { useEffect, useMemo, useState } from "react";
import { MessageContext, messageContext, MessageListener } from "./context";

export const MessageProvider = ({ children }: React.PropsWithChildren) => {

    const [listeners, setListeners] = useState<MessageListener[]>([]);

    const value: MessageContext = useMemo(() => ({
        addListener: (func) => {
            setListeners(curr => [...curr, func])
        },
        removeListener: (func) => {
            setListeners(curr => curr.filter(f => f !== func))
        },
        post: (payload) => {
            const targetWindow = window.parent;
            if (window.parent) {
                targetWindow.postMessage({ source: "myhealth-booking-ui", payload }, "*");
            }
        }
    }), []);

    useEffect(() => {
        function eventListener(event: MessageEvent) {
            if (import.meta.env.MODE === "production" && !event.origin.includes("myhealth.net.au")) {
                return;
            }
            if (typeof event.data === "object"
                && typeof event.data.source === "string"
                && (event.data.source as string).startsWith("myhealth")) {
                listeners.forEach((l) => {
                    l(event.data.payload);
                })
            }
        }
        window.addEventListener("message", eventListener);
        return () => window.removeEventListener("message", eventListener);
    }, [listeners]);

    return <messageContext.Provider value={value}>
        {children}
    </messageContext.Provider>
}
